import { ICustomIconProps } from './types';

const IconHouse: React.FC<ICustomIconProps> = ({ size = 20, color = '#ffffff' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10 15.5C9.59 15.5 9.25 15.84 9.25 16.25V17.75C9.25 18.16 9.59 18.5 10 18.5C10.41 18.5 10.75 18.16 10.75 17.75V16.25C10.75 15.84 10.41 15.5 10 15.5Z'
      fill={color}
    />
    <path
      d='M22 21.2502H21V9.98021C21 9.36021 20.72 8.78021 20.23 8.40021L13.23 2.96021C12.51 2.39021 11.49 2.39021 10.77 2.96021L3.77 8.40021C3.28 8.78021 3 9.36021 3 9.97021L2.95 21.2502H2C1.59 21.2502 1.25 21.5802 1.25 22.0002C1.25 22.4102 1.59 22.7502 2 22.7502H22C22.41 22.7502 22.75 22.4102 22.75 22.0002C22.75 21.5802 22.41 21.2502 22 21.2502ZM10.5 6.75021H13.5C13.91 6.75021 14.25 7.09021 14.25 7.50021C14.25 7.91021 13.91 8.25021 13.5 8.25021H10.5C10.09 8.25021 9.75 7.91021 9.75 7.50021C9.75 7.09021 10.09 6.75021 10.5 6.75021ZM17 21.2502H7V12.5002C7 11.6702 7.67 11.0002 8.5 11.0002H15.5C16.33 11.0002 17 11.6702 17 12.5002V21.2502Z'
      fill={color}
    />
  </svg>
);

export default IconHouse;
